import React from "react";

function SalesDetails({ sale, onClose }) {
  if (!sale) return null;

  return (
    <div className="fixed top-0 right-0 w-full md:w-1/3 h-full bg-white shadow-lg z-50 flex flex-col">
      {/* Header */}
      <div className="flex justify-between items-center p-4 border-b bg-gray-100">
        <h2 className="text-xl font-bold text-gray-800">Sales Details</h2>
        <button
          className="text-gray-600 hover:text-gray-900 text-2xl"
          onClick={onClose}
        >
          &times;
        </button>
      </div>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto p-6 space-y-6">
        {/* Header Section */}
        <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
          <h3 className="text-lg font-bold text-gray-800 mb-3 border-b pb-2">
            Sale Information
          </h3>
          <p>
            <span className="text-sm font-semibold text-gray-600">Sale ID:</span>{" "}
            <span className="text-gray-800">{sale.sale_id}</span>
          </p>
          <p>
            <span className="text-sm font-semibold text-gray-600">Customer:</span>{" "}
            <span className="text-gray-800">{sale.customer_name}</span>
          </p>
          <p>
            <span className="text-sm font-semibold text-gray-600">Date:</span>{" "}
            <span className="text-gray-800">{sale.sale_date}</span>
          </p>
        </div>

        {/* Deal Details Section */}
        <div className="bg-white p-4 rounded-lg shadow-sm">
          <h3 className="text-lg font-bold text-gray-800 mb-3 border-b pb-2">
            Deal Details
          </h3>
          <p>
            <span className="text-sm font-semibold text-gray-600">Final Deal Value:</span>{" "}
            <span className="text-gray-800">${sale.total_amount}</span>
          </p>
          <p>
            <span className="text-sm font-semibold text-gray-600">Discount Applied:</span>{" "}
            <span className="text-gray-800">${sale.discount_applied || 0}</span>
          </p>
          <p>
            <span className="text-sm font-semibold text-gray-600">Payment Status:</span>{" "}
            <span className="text-gray-800">{sale.payment_status}</span>
          </p>
        </div>

        {/* Product/Service Section */}
        <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
          <h3 className="text-lg font-bold text-gray-800 mb-3 border-b pb-2">
            Product/Service
          </h3>
          <p>
            <span className="text-sm font-semibold text-gray-600">Product:</span>{" "}
            <span className="text-gray-800">{sale.product_name}</span>
          </p>
          <p>
            <span className="text-sm font-semibold text-gray-600">Quantity:</span>{" "}
            <span className="text-gray-800">{sale.quantity}</span>
          </p>
          <p>
            <span className="text-sm font-semibold text-gray-600">Unit Price:</span>{" "}
            <span className="text-gray-800">${sale.unit_price}</span>
          </p>
        </div>

        {/* Delivery Section */}
        <div className="bg-white p-4 rounded-lg shadow-sm">
          <h3 className="text-lg font-bold text-gray-800 mb-3 border-b pb-2">
            Delivery Details
          </h3>
          <p>
            <span className="text-sm font-semibold text-gray-600">Delivery Address:</span>{" "}
            <span className="text-gray-800">{sale.delivery_address}</span>
          </p>
          <p>
            <span className="text-sm font-semibold text-gray-600">Delivery Date:</span>{" "}
            <span className="text-gray-800">{sale.delivery_date}</span>
          </p>
          <p>
            <span className="text-sm font-semibold text-gray-600">Delivery Status:</span>{" "}
            <span className="text-gray-800">{sale.delivery_status}</span>
          </p>
        </div>

        {/* Notes Section */}
        <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
          <h3 className="text-lg font-bold text-gray-800 mb-3 border-b pb-2">
            Notes and Attachments
          </h3>
          <p>
            <span className="text-sm font-semibold text-gray-600">Internal Notes:</span>{" "}
            <span className="text-gray-800">{sale.notes || "N/A"}</span>
          </p>
        </div>
      </div>

      {/* Sticky Footer */}
      <div className="p-4 border-t bg-gray-100">
        <button
          className="bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded-md"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
}

export default SalesDetails;